var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import ReactJsPopup from "reactjs-popup";
import { useTheme } from "styled-components";
/** Popup functional component. */
export const Popup = (_a) => {
    var { contentStyle = {} } = _a, rest = __rest(_a, ["contentStyle"]);
    const theme = useTheme();
    const { colors: { popupColors }, } = theme;
    const defaultContentStyle = {
        backgroundColor: popupColors.background,
        border: theme.borders[1],
        borderColor: popupColors.border,
        borderRadius: theme.radii[1],
        padding: theme.space[3],
    };
    const arrowStyle = {
        color: popupColors.background,
    };
    return React.createElement(ReactJsPopup, Object.assign({ arrowStyle: arrowStyle, contentStyle: Object.assign(Object.assign({}, defaultContentStyle), contentStyle) }, rest));
};
